import React from 'react';
import type { CmdbObjectAttributeDefault } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeDefault;
};

export const BooleanAttribute = (props: Props): React.JSX.Element => {
	const { attribute } = props;
	return (
		<>
			{attribute.objectAttributeValues.map((value, index) => (
				<div data-testid="servicedesk-insight-attribute-list.ui.boolean-attribute" key={index}>
					{value.displayValue}
				</div>
			))}
		</>
	);
};
